import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { getMockups, deleteMockup } from "actions/mockupAction";
import { ReactTable } from "components/Table";
import { ListDateType } from "helper/constant";
import ReactImageMagnify from 'react-image-magnify';
import {
    formatterCreateAt,
    convertTZ,
} from "components/Function";
import Loading from "components/Loading";

const PRODUCT_OPTIONS = {
    "T-SHIRT": ["BLACK", "WHITE", "SPORT GREY", "SAND", "FOREST GREEN", "LIGHT PINK", "NAVY", "MILITARY GREEN", "MAROON", "RED", "ROYAL BLUE", "ASH GREY", "LIGHT BLUE", "CHARCOAL", "DARK HEATHER", "PURPLE", "ORANGE"],
    "YOUTH T-SHIRT": ["BLACK", "WHITE", "IRISH GREEN", "LIGHT PINK", "FOREST GREEN"],
    "SWEATSHIRT": ["BLACK", "WHITE", "SPORT GREY", "SAND", "FOREST GREEN", "LIGHT PINK", "NAVY", "MILITARY GREEN", "MAROON", "RED", "ROYAL BLUE", "ASH GREY", "ORANGE", "DARK HEATHER"],
    "HOODIE": ["BLACK", "WHITE", "SPORT GREY", "SAND", "FOREST GREEN", "LIGHT PINK", "NAVY"],
    "TANK TOP": ["BLACK", "WHITE", "SPORT GREY", "NAVY"],
    "COMFORT COLOR": ["BLACK", "WHITE", "PEPPER", "IVORY", "ESPRESSO", "BLUE SPRUCE", "CRIMSOM", "BAY", "MOSS", "BLUE JEAN", "SEAFOAM", "GREY", "BLOSSOM", "GRAPHITE", "VIOLET"],
    "WASHED": ["BLACK", "GREY"],
    "MUG": ["BLACK", "WHITE"],
    "POSTER-CANVAS": ["BLACK", "WHITE"],
    "BLANKET": ["BLACK", "WHITE"],
    "ORNAMENT": ["BLACK", "WHITE"],
};

const COLOR_HEX = {
    "BLACK": "#000000",
    "WHITE": "#FFFFFF",
    "SPORT GREY": "#C0C0C0",
    "SAND": "#F5DEB3",
    "FOREST GREEN": "#228B22",
    "LIGHT PINK": "#FFB6C1",
    "NAVY": "#000080",
    "MILITARY GREEN": "#4B5320",
    "MAROON": "#800000",
    "RED": "#FF0000",
    "ROYAL BLUE": "#4169E1",
    "ASH GREY": "#B2BEB5",
    "LIGHT BLUE": "#ADD8E6",
    "CHARCOAL": "#36454F",
    "DARK HEATHER": "#A9A9A9",
    "PURPLE": "#800080",
    "ORANGE": "#FFA500",
    "IRISH GREEN": "#00A550",
    "PEPPER": "#3C3C3C",
    "IVORY": "#FFFFF0",
    "ESPRESSO": "#4B2E2B",
    "BLUE SPRUCE": "#317873",
    "CRIMSOM": "#DC143C",
    "BAY": "#A3C1AD",
    "MOSS": "#8A9A5B",
    "BLUE JEAN": "#5D8AA8",
    "SEAFOAM": "#93E9BE",
    "GREY": "#808080",
    "BLOSSOM": "#FFD3E0",
    "GRAPHITE": "#383838",
    "VIOLET": "#8F00FF"
};


const MockupList = ({
    getMockups,
    mockup,
    formatterCreateAt,
    deleteMockup,
}) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("");
    const [mockups_selected, setMockupSelected] = useState([]);
    const [filter, setFilter] = useState({});
    const [productType, setProductType] = useState([]);
    const [productColor, setProductColor] = useState([]);


    const { t } = useTranslation();

    const { list, totalsize, isLoading } = mockup;

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "20",
            value: 20,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "All",
            value: totalsize || 50,
        },
    ];

    useEffect(() => {
        if (Object.keys(filter).length) {
            getMockups({ page, sizeperpage: sizePerPage, search: searchText, filter });
        }
    }, [getMockups, page, sizePerPage, searchText, filter]);

    const handleDelete = async () => {
        await deleteMockup({ _id: mockups_selected });
    };

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        setPage(1);
        setSizePerPage(50);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        // eslint-disable-next-line
    }, [dateType]);

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "preview_mockup",
            text: t("Mockup"),
            sort: true,
            editable: false,
            formatter: (cell, row) => (
                <>
                    <div className="symbol symbol-50px">
                        <Link to={cell} target="_blank"><ReactImageMagnify {...{ smallImage: { alt: "", width: 200, height: 200, src: cell || require("components/assets/media/misc/image.png") }, largeImage: { src: cell || require("components/assets/media/misc/image.png"), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '300%', height: '300%' }, enlargedImageContainerStyle: { "zIndex": 99 }, className: "cursor-pointer", enlargedImageContainerClassName: "al-zoom-img-cus" }} /></Link>
                    </div>
                </>
            ),
        },
        {
            dataField: "productType",
            text: t("Product Type"),
            sort: true,
            editable: false,
        },
        {
            dataField: "productColor",
            text: t("Product Color"),
            sort: true,
            editable: false,
            formatter: (cell, row) => (
                <>
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <span style={{
                            width: 100,
                            height: 100,
                            backgroundColor: COLOR_HEX[cell] || "#ccc",
                            border: '1px solid #000',
                            display: 'inline-block',
                            borderRadius: 4
                        }} />
                        <span style={{ fontWeight: 'bold' }}>{cell}</span>
                    </div>
                </>
            ),
        },
    ];

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const colorOptions = Object.entries(COLOR_HEX).map(([label, hex]) => ({
        label,
        value: label,
        color: hex
    }));

    const productOptions = Object.keys(PRODUCT_OPTIONS).map((name) => ({
        label: name,
        value: name
    }));

    const formatColorLabel = ({ label, color }) => (
        <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{
                backgroundColor: color,
                width: 16,
                height: 16,
                borderRadius: "50%",
                display: "inline-block",
                marginRight: 10,
                border: "1px solid #ccc"
            }}></span>
            {label}
        </div>
    );

    const onChangeProductType = (e) => {
        var tier_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilter((prev) => ({
            ...prev,
            productType: tier_tmp || [],
        }));
        setProductType(tier_tmp);
    };

    const onChangeProductColor = (e) => {
        var tier_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilter((prev) => ({
            ...prev,
            productColor: tier_tmp || [],
        }));
        setProductColor(tier_tmp);
    };

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(50);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    };

    const onSelect = (row, isSelect) => {
        var mockups_selected_tmp = mockups_selected;
        if (isSelect) {
            mockups_selected_tmp.push(row._id);
        } else {
            mockups_selected_tmp = removeSelect(mockups_selected_tmp, row._id);
        }
        var new_arr = JSON.stringify(mockups_selected_tmp);
        setMockupSelected(JSON.parse(new_arr));
        if (mockups_selected_tmp.length !== 0) {
            // setLoadingSync(false);
        }
        if (mockups_selected_tmp.length === 0) {
            // setLoadingSync(true);
        }
    };

    const onSelectAll = (isSelect, row) => {
        var mockups_selected_tmp = mockups_selected;
        if (isSelect) {
            mockups_selected_tmp = row.map((v, i) => v._id);
        } else {
            mockups_selected_tmp = [];
        }
        setMockupSelected(mockups_selected_tmp);
        if (mockups_selected_tmp.length !== 0) {
            // setLoadingSync(false);
        }
        if (mockups_selected_tmp.length === 0) {
            // setLoadingSync(true);
        }
    };

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        selected: mockups_selected,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
            <div className="d-flex">
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = indeterminate;
                            input.checked = checked;
                        }
                    }}
                    onChange={onChange}
                />
                <span style={{ marginLeft: '8px' }}>({mockups_selected.length})</span>
            </div>
        ),
    };

    const handleChange = async (data) => {
        // await updatePromotionAutomate({ _id: shopsSelect, ...data });
    };

    const groupButton = () => {
        return (
            <>
                <div className="mb-5 d-flex flex-md-row flex-column gap-2">
                    <Link to={"/admin/mockup-create"}
                        className="btn btn-sm btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#kt_modal_create_app"
                        id="kt_toolbar_primary_button"
                    >
                        {t("New Mockup")}
                    </Link>
                    <button
                        className="btn btn-sm btn-danger"
                        data-bs-toggle="modal"
                        data-bs-target="#kt_modal_create_app"
                        id="kt_toolbar_primary_button"
                        onClick={handleDelete}
                    >
                        {t("Delete")}
                    </button>
                    <Select
                        isClearable
                        isMulti
                        name="productType"
                        options={productOptions}
                        className="cotik-select-virtual"
                        classNamePrefix="select"
                        value={productOptions.filter(({ value }) => productType.includes(value))}
                        onChange={(e) => {
                            onChangeProductType(e);
                        }}
                        placeholder={t("Select type ... ")}
                    />
                    <Select
                        isClearable
                        isMulti
                        name="productColor"
                        options={colorOptions}
                        className="cotik-select-virtual"
                        classNamePrefix="select"
                        formatOptionLabel={formatColorLabel}
                        value={colorOptions.filter(({ value }) => productColor.includes(value))}
                        onChange={(e) => {
                            onChangeProductColor(e);
                        }}
                        placeholder={t("Select color ... ")}
                    />
                    <Select
                        name="dateType"
                        options={ListDateType}
                        className="al-select"
                        classNamePrefix="select"
                        value={ListDateType.filter(({ value }) => value === dateType)}
                        onChange={(e) => {
                            setDateType(e?.value || "");
                        }}
                        placeholder="Select a date ... "
                    />
                    {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                        <DateRangePicker
                            onCallback={handleEventDate}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                            }}
                        >
                            <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                        </DateRangePicker>
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <div className="card min-w-full">
                <Loading isLoading={isLoading} />
                <div className="card-body">
                    <div className="al-variants-table al-max-height-table-cus">
                        <ReactTable
                            columns={columns}
                            data={list || []}
                            groupButton={groupButton}
                            handleTableChange={handleTableChange}
                            page={page}
                            sizePerPage={sizePerPage}
                            totalSize={totalSize}
                            alClassName="table-layout-inherit al-d-none-option-react-select"
                            sizePerPageList={sizePerPageList}
                            isSelectRow={true}
                            selectRow={selectRow}
                            isCellEdit={true}
                        />
                    </div>
                </div>
            </div>
        </>

    );
};

const mapStateToProps = ({ mockup }) => ({ mockup });
const mapDispatchToProps = {
    formatterCreateAt,
    getMockups,
    deleteMockup,
};

export default connect(mapStateToProps, mapDispatchToProps)(MockupList);